import { useState, useEffect } from "react";
import axios from "axios";
import { Globe, ArrowRight, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DISMISS_KEY = "byod_banner_dismissed";

export const ByodBanner = ({ token }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY) === "1") return;
    axios
      .get(`${API}/user/custom-domains`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        // Only nudge licensed users who haven't added a custom domain yet
        if ((res.data.domains || []).length === 0) setShow(true);
      })
      .catch(() => {}); // unlicensed / not allowed -> stay hidden
  }, [token]);

  if (!show) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  return (
    <div
      className="relative overflow-hidden rounded-xl border border-cyan-500/30 bg-gradient-to-r from-cyan-500/10 via-slate-800/40 to-slate-800/40 p-4 sm:p-5"
      data-testid="byod-banner"
    >
      <div className="flex items-center gap-4">
        <div className="p-2.5 rounded-lg bg-cyan-500/20 shrink-0">
          <Globe className="w-5 h-5 text-cyan-400" />
        </div>
        <div className="min-w-0">
          <h3 className="text-white font-semibold">Use your own branded domain</h3>
          <p className="text-sm text-slate-400">
            Point a domain like <span className="text-slate-300">go.yourbrand.com</span> to us and we'll set up SSL automatically — it takes about a minute.
          </p>
        </div>
        <a
          href="/redirector?tab=my-domains"
          className="ml-auto hidden sm:flex items-center gap-1.5 px-4 py-2 bg-cyan-600 hover:bg-cyan-500 text-white text-sm rounded-lg transition-colors shrink-0"
          data-testid="byod-banner-cta"
        >
          Add your domain <ArrowRight className="w-4 h-4" />
        </a>
        <button
          onClick={dismiss}
          className="p-1.5 text-slate-500 hover:text-white shrink-0"
          title="Dismiss"
          data-testid="byod-banner-dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      <a href="/redirector?tab=my-domains" className="sm:hidden mt-3 flex items-center justify-center gap-1.5 px-4 py-2 bg-cyan-600 hover:bg-cyan-500 text-white text-sm rounded-lg" data-testid="byod-banner-cta-mobile">
        Add your domain <ArrowRight className="w-4 h-4" />
      </a>
    </div>
  );
};
